  <template>
  <v-form>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model.trim="$v.user.password.$model"
            :error-messages="passwordError"
            prepend-icon="mdi-lock"
            name="password"
            label="Senha"
            type="password"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model.trim="$v.user.repassword.$model"
            :error-messages="repasswordError"
            prepend-icon="mdi-lock"
            name="repassword"
            label="Repita a Senha"
            type="password"
          />
        </v-col>
        <v-spacer />
        <v-col cols="12" class="col-12 d-flex justify-lg-space-between">
          <v-btn large @click.prevent="voltar"> Voltar </v-btn>
          <v-btn
            :disabled="$v.$invalid || disableSubmit ? true : false"
            color="primary"
            large
            type="submit"
            @click.prevent="submit"
          >
            Enviar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
export default {
  name: 'NovaSenha',
  data: () => ({
    user: {
      password: '',
      repassword: ''
    },
    disableBtn: false
  }),
  validations: {
    user: {
      password: {
        required,
        minLength: minLength(6)
      },
      repassword: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  computed: {
    passwordError () {
      const errors = [];
      const password = this.$v.user.password;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push('Senha é obrigatorio')
      !password.minLength && errors.push(`Senha deve conter ${password.$params.minLength.min} caracteres`)
      return errors;
    },
    repasswordError () {
      const errors = [];
      const password = this.$v.user.repassword;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push('Senha é obrigatorio')
      !password.sameAsPassword && errors.push(`As Senha devem ser iguais `)
      return errors;
    },
    disableSubmit: {
      set (value) {
        this.disableBtn = value
      },
      get () {
        return this.disableBtn
      }
    }
  },
  methods: {
    voltar () {
      this.$emit('action', { page: 1 })
    },
    submit () {
      this.disableSubmit = true;
      let data = {
        id: this.$store.getters.getEmailRecuperacao,
        pwd: this.$paguefacil.md5(this.user.password),
      };
      this.$paguefacil.changePassword(data)
        .then(res => {
            this.disableSubmit = false;
          if (res.data.status==0) {
            this.$store.dispatch('MsgSucces', res.data.msg)
            this.$store.dispatch('displayMsgSuccess', true)
            //
            this.$emit('action', { page: 1 })
          }
          if (res.data.status != 0) {
              this.$store.dispatch('setMsgError', res.data.msg)
              this.$store.dispatch('setDisplayMsgErr',true)
              return false;
          }
        },
          (e) => {
            this.disableSubmit = false;
            this.$store.dispatch('setMsgError', e.response.data.message)
            this.$store.dispatch('setDisplayMsgErr', true)
            this.$store.dispatch('resetToken')
          })
    }
  }
}
</script>